import { type Actions, ActionType } from './attributes.actions';
import { attributeAdapter, initialState, type State } from './attributes.state';

export function attributesReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.RESET: {
            return initialState;
        }
        case ActionType.FETCH_ATTRIBUTES: {
            return { ...state, isPending: true };
        }
        case ActionType.FETCH_ATTRIBUTES_SUCCEEDED: {
            return attributeAdapter.setAll(action.payload.attributes, { ...state, isLoaded: true, isPending: false });
        }
        case ActionType.FETCH_ATTRIBUTES_FAILED: {
            return { ...state, isLoaded: false, isPending: false };
        }
        case ActionType.ADD_ATTRIBUTE: {
            return attributeAdapter.addOne(action.payload.attribute, state);
        }
        case ActionType.UPDATE_ATTRIBUTE: {
            return attributeAdapter.updateOne(
                {
                    id: action.payload.attributeId,
                    changes: action.payload.attributeUpdate
                },
                state
            );
        }
        case ActionType.DELETE_ATTRIBUTE: {
            return attributeAdapter.removeOne(action.payload.attributeId, state);
        }
        case ActionType.UPDATE_RANK: {
            return attributeAdapter.updateMany(
                action.payload.map(newRanks => {
                    return { id: newRanks.attributeId, changes: newRanks.rank };
                }),
                state
            );
        }
        default:
            return state;
    }
}
